__webpack_require__.p = "https://order-details.dev.core-artifacts.com/static/";